export const INIT_SETTINGS = "INIT_SETTINGS";
export const START_AJAX_REQUEST = "START_AJAX_REQUEST";
export const END_AJAX_REQUEST = "END_AJAX_REQUEST";


// WEBPACK FOOTER //
// ./src/_app/drafts/constants/settings-constants.js